<script>
    import { Router, Link, Route, navigate } from "svelte-routing";
    import { onMount, tick } from 'svelte';
    import {STUDY_MONITORING_ACCESS} from '../orgAccessControl'
    import Navigation from "./layout/navigation.html";
    import Header from "./layout/header.html";

    import Home from "./home/home.html";
    import MyProfile from "./myProfile/index.html";
    import Reports from "./report/index.html";
    import Enquiry from "./enquiries/index.html";

    import AccessProfileFeatures from "./accessProfile/features.html"
    import Responses from "./response/index.html"
    import EnquirySource from "./enquirySource/index.html";
    import StudyMonitoring from "./studyMonitoring/index.html"
    import Student from "./students/index.html";
    import Attendance from "./attendance/index.html";
    import StudentAttendance from "./studentAttendance/index.html";
    import LiveLectureForStudents from "./liveLectureForStudent/index.html"
    import StudentStudyMaterial from "./studyMaterialStudent/index.html"
    import CustomFields from "./customFields/index.html"
    import StudyMaterial from "./studyMaterialNew/index.html";
    import Batch from "./batch/index.html";
    import BatchTiming from "./batch_timing/index.html";
    import Holiday from "./holiday/index.html";
    import Branch from "./branch/index.html";
    import Course from "./course/index.html";
    import Classes from "./class/index.html";
    // import ModuleSubject from "./categories/index.html";
    import SystemUser from "./systemUser/index.html";
    import Schedule from "./schedule/index.html";
    import TeleCallers from "./teleCallers/index.html";
    import TeleScript from "./TelecallerScriptTextEditor/container.html";
    import SmsTemplate from "./SmsTemplateTextEditor/container.html";
    import AnnouncementTemplate from "./AnnouncementsTextEditor/container.html";
    import TaskManagement from "./taskManagement/index.html";
    import Settings from "./settings/index.html";
    import GeneralSettings from "./settings/general/index.html";
    import SocialSettings from "./settings/social/index.html";
    // import PointsSettings from "./settings/points/index.html";
    import IntegrationSettings from "./settings/integration/index.html";
    import Feedback from "./feedbackAdmin/index.html";
    import StudentFeedback from "./feedbackStudent/index.html";
    import StudentStudyReport from "./studyReportStudent/index.html";
    import StudyReport from "./studyReportAdmin/index.html";
    import AccessProfile from "./accessProfile/index.html";
    import FAQ from "./faq/index.html";
    import FolderCmp from "./folderCmp/folderCmp.html"
    import Payment from "./payment/index.html";
    import PdcManagement from "./postDatedCheck/index.html";
    import ReceiptSeries from "./receiptSeries/index.html";
    import QuestionsReported from "./questionsReported/index.html"
    import QuestionsReportedType from "./questionsReportedType/index.html"
    import DiscussionForum from './discussionForum/index.html'
    import LeaveRequest from "./leaveRequest/index.html"
    import OrgTree from "./orgTree/newOrgTree.html"
    import StudentView from "./studentView/index.html";
    import Questions from "./questions/index.html"
    import QuestionsUpload from "./questionUpload/index.html"
    import AnalyticalCategory from "./analyticalCategory/index.html"
    import Tests from "./tests/index.html"
    import MyTests from "./tests/myTests.html"
    import PracticeTest from "./tests/practiceTest.html"

    import ExamReports from "./tests/myExamReports.html"
    import TestInstructions from "./TestInstructionsTextEditor/container.html"
    import SPT from "./singleParamTextEditor/container.html"
    import StudyMonitoringSources from "./studyMonitoringSources/index.html"

    import { userData } from "./stores";

    import { _accessToken } from "../store.js";
    import { get } from 'svelte/store';
    import AppSlider from "./appSlider/index.html";
    import Assignment from "./assignment/index.html";
    import AssignmentProgress from "./assignment_progress/index.html"
    import BatchJoinRequest from "./batchJoinRequest/index.html"
    import ViewAttendance from "./viewAttendance/index.html";
    import StudentAssignment from "./studentAssignment/index.html";
    import Chat from "./chat/index.html";
    import Announcements from "./announcements/index.html";
    import DoubtSession from "./doubtSession/index.html";

    import MODULES from "./utils/modules";
    import Forbidden from "./forbidden.html";

    let isUserLoaded = false;
    let localUserData = {
        fullName: '...',
        role: "...",
        avatar: "/images/man.png",
        access: {
            home: false,
            students: false,
            settings: false
        }
    };

    const unsubscribe = userData.subscribe(value => {
        localUserData = value;
    });

    const keyShortcutInit = () => {
        window.addEventListener('keydown', function (e) {
            if (e.altKey == true  && e.keyCode == 80) {
                if(MODULES.hasAccess(MODULES.MANAGE_PAYMENT)){
                    navigate('/dashboard/payment/')
                }

            }
                
            // else if(e.keyCode == 17 && e.keyCode == 18 && e.keyCode == 80)navigate('/dashboard/payment/')
        })
    }
    async function checkCurrentUser() {
        const accessToken = window.localStorage.getItem("accessToken")
        if (!accessToken) {
            alert("No Access Token found");
            navigate("/login");
            return;
        }
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var payload = JSON.stringify({
            action: "auth.getCurrentUser",
            accessToken: accessToken,
            data: {
                withAccessProfile: true,
                getFresh: true
            }
        });
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: payload,
        };
        try {
            
            var resObj = await fetch(API_URL, requestOptions);
            var response = await resObj.json();
            // console.log("getCurrentUser : ", response);
            // console.log( 'responsedaata',response.data)
            if(!response.status){
                navigate("/login");
                return;
            }
            if(response.data.role == "student" && response.data.admissionCancel === true) {
                navigate("/canceladmission");
                return;
            }
            if(response.data.role == "student" && response.data.inactive === true) {
                navigate("/inactive");
                return;
            }
            if(response.data.role == "parent") {
                navigate("/restricted");
                return;
            }

            var defaultAvatar = "/images/man.png";
            userData.set({
                _id: response.data.userId,
                fullName: response.data.name,
                role: response.data.role,
                orgName: response.data.orgName,
                mobileNo: response.data.mobileNo,
                avatar: response.data.profilePic ? response.data.profilePic : defaultAvatar,
                access: {},
                modules : response.data.modules,
                orgId: response.data.orgId,
                orgCode: response.data.orgCode
            });
            // console.log("MODULES.hasAccess(MODULES.PUT) : ", MODULES.hasAccess(MODULES.ADD_BATCH));
            setTimeout(()=>{
                isUserLoaded = true;
                tick();
            },10)
        } catch (error) {
            navigate("/login");
            // console.error("error", error);
            console.log({ error: error });
        }
    }

    let init = () => {
        checkCurrentUser();
        keyShortcutInit()
        // called once for context menu
        _$(document).bind("mousedown", function (e) {
            if (!_$(e.target).parents(".custom-menu").length > 0) {
                _$(".custom-menu").hide(100);
                _$(".action-span").css({ outline: 0, "background-color": "white" })
            }
        });
    }

    onMount(async () => {
        init();
    })

</script>


{#if isUserLoaded}
<Navigation></Navigation>
<div class="content ht-100v pd-0 fadeIn">
    <Header></Header>

    <Router>

        {#if localUserData.role == 'student'}

            <Route path="/">
                <MyTests />
            </Route>

            <Route path="/practiceTest">
                <PracticeTest />
            </Route>

            <Route path="/exam-reports">
                <ExamReports userId={localUserData._id} />
            </Route>

            <Route path="/studentAttendance/*">
                <StudentAttendance />
            </Route>

            <Route path="/lectures/*">
                <LiveLectureForStudents />
            </Route>

            <Route path="/studentStudyMaterial/*">
                <StudentStudyMaterial />
            </Route>

            <Route path="/studentAssignment/*">
                <StudentAssignment />
            </Route>

            <Route path="/reports/study/*">
                <StudentStudyReport />
            </Route>

            <Route path="/holidays/*">
                <Holiday />
            </Route>

            <Route path="/studentFeedback/*">
                <StudentFeedback />
            </Route>

        {/if}

        {#if localUserData.role != 'student' || localUserData.role != 'parent'}

            {#if MODULES.hasAccess(MODULES.ADMIN_DASHBOARD)}
            <Route path="/">
                <Home />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.ADMIN_DASHBOARD)}
            <Route path="/home">
                <Home />
            </Route>
            {/if}

            <Route path="/batch/*">
                {#if MODULES.hasAccess(MODULES.MANAGE_BATCH)}
                    <Batch />
                {:else}
                    <Forbidden /> 
                {/if}
            </Route>

            {#if MODULES.hasAccess(MODULES.MANAGE_JOIN_REQUEST)}
            <Route path="/batchJoinRequest/*">
                <BatchJoinRequest />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_ATTENDANCE)}
            <Route path="/attendance/*">
                <Attendance />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_ATTENDANCE)}
            <Route path="/viewAttendance/*">
                <ViewAttendance />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_CLASS_TIMINGS)}
            <Route path="/classtiming/*">
                <BatchTiming />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_HOLIDAYS)}
            <Route path="/holidays/*">
                <Holiday />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_BRANCH)}
            <Route path="/branch/*">
                <Branch />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_COURSE)}
            <Route path="/course/*">
                <Course />
            </Route>
            {/if}
            
            {#if MODULES.hasAccess(MODULES.MANAGE_CLASSES)}
            <Route path="/class/*">
                <Classes />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_ENQUIRY)}
            <Route path="/enquiries/*">
                <Enquiry />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_STUDENT)}
            <Route path="/students/*">
                <Student />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_STUDENT)}
            <Route path="student/view/:id/*" let:params>
                <StudentView studentId="{params.id}" />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_ASSIGNMENT)}
            <Route path="/assignment/*">
                <Assignment />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_ASSIGNMENT)}
            <Route path="/assignmentprogress/*">
                <AssignmentProgress />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_PAYMENT)}
            <Route path="payment/*">
                <Payment />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_PAYMENT)}
            <Route path="pdc/*">
                <PdcManagement />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_PAYMENT)}
            <Route path="receiptSeries/*">
                <ReceiptSeries />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_FEEDBACK)}
            <Route path="/feedback/*">
                <Feedback />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_DISCUSSION_FORUM)}
            <Route path="/discussionForum/*">
                <DiscussionForum />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_QUESTION_BANK)}
            <Route path="questions/*">
                <Questions />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_QUESTION_BANK)}
            <Route path="questions_upload/*">
                <QuestionsUpload />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_QUESTION_BANK)}
            <Route path="questionsreported/*">
                <QuestionsReported />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_QUESTION_BANK)}
            <Route path="questionsreportedtype/*">
                <QuestionsReportedType />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_TEST)}
            <Route path="tests/*">
                <Tests />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_TEST)}
            <Route path="myTests/*">
                <MyTests />
            </Route>
            {/if}
            
            {#if MODULES.hasAccess(MODULES.MANAGE_TEST)}
            <Route path="/exam-reports">
                <ExamReports userId={localUserData._id} />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_STUDY_MATERIAL)}
            <Route path="/studyMaterial/*">
                <StudyMaterial />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_STUDY_REPORT)}
            <Route path="/reports/study/*">
                <StudyReport />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_SYSTEM_USERS)}
            <Route path="/systemuser/*">
                <SystemUser />
            </Route>
            {/if}


            {#if MODULES.hasAccess(MODULES.SCHEDULE)}
            <Route path="/schedule/*">
                <Schedule />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_TASKS)}
            <Route path="/tasks/*" let:params>
                <TaskManagement />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_LEAVES)}
            <Route path="/leave-request">
                <LeaveRequest userRole={localUserData.role} />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_TELE_CALLER_LOGS)}
            <Route path="/telelogs/*">
                <TeleCallers />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_DAILY_STAFF_REPORTING)}
            <Route path="/reportings">
                <Reports />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_MY_PROFILE)}
            <Route path="/myprofile">
                <MyProfile />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_GENERAL_SETTINGS)}
            <Route path="/settings/:tab" let:params>
                <Settings tab={params.tab} />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_APP_SLIDER)}
            <Route path="/appslider">
                <AppSlider />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_ANNOUNCEMENTS)}
            <Route path="announcements/*">
                <Announcements />
            </Route>
            {/if}
            
            {#if MODULES.hasAccess(MODULES.MANAGE_DOUBT_SESSION)}
            <Route path="doubtSession/*">
                <DoubtSession />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_FAQ)}
            <Route path="/faq">
                <FAQ />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_SMS_TEMPLATES)}
            <Route path="/smstemplate/*">
                <SmsTemplate />
            </Route>
            {/if}
            {#if MODULES.hasAccess(MODULES.MANAGE_ANNOUNCEMENT_TEMPLATE)}
            <Route path="/announcementtemplate/*">
                <AnnouncementTemplate />
            </Route>
            {/if}
            
            {#if MODULES.hasAccess(MODULES.MANAGE_TELE_CALLER_SCRIPTS)}
            <Route path="/telescript/*">
                <TeleScript />
            </Route>
            {/if}
            
            {#if MODULES.hasAccess(MODULES.MANAGE_TEST_INST)}
            <Route path="tests/instructions/*">
                <TestInstructions />
            </Route>
            {/if}
            
            {#if MODULES.hasAccess(MODULES.MANAGE_ANALYTICAL_CATEGORY)}
            <Route path="analyticalCategory/*">
                <AnalyticalCategory />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_ENQUIRY_RESPONSES)}
            <Route path="/enquiries/response">
                <Responses />
            </Route>
            {/if}

            {#if MODULES.hasAccess(MODULES.MANAGE_ENQUIRY_SOURCE)}
            <Route path="/enquiries/source/*">
                <EnquirySource />
            </Route>
            {/if}

            

        {/if}
        {#if localUserData && STUDY_MONITORING_ACCESS.indexOf(localUserData.orgCode.toString()) != -1 }
            <!-- {#if MODULES.hasAccess(MODULES.MANAGE_STUDY_MONITORING_SOURCE)} -->
            <Route path="/studymonitoringsources/*">
                <StudyMonitoringSources />
            </Route>
            <!-- {/if} -->
            <Route path="/studyMonitoring/*">
                <StudyMonitoring />
            </Route>
        {/if}

        <!-- <Route path="/chat/*">
            <Chat />
        </Route> -->

        <!-- <Route path="enquiries/reports">
            <Reports from="enquiries" />
        </Route> -->

        <!-- <Route path="/accessProfile/*">
            <AccessProfile />
        </Route> -->

        <!-- <Route path="/modulesubject/*">
            <ModuleSubject />
        </Route> -->

        <!-- <Route path="/customFields/*">
            <CustomFields />
        </Route> -->

        <!-- <Route path="/accessProfileFeatures">
            <AccessProfileFeatures />
        </Route> -->

        <!-- <Route path="folders/*">
            <FolderCmp />
        </Route> -->

        <!-- <Route path="spt/*">
            <SPT />
        </Route>

        <Route path="orgTree/*">
            <OrgTree />
        </Route> -->

    </Router>
<!-- 
    <ul class='custom-menu'>
        <li data-action="first">First thing</li>
        <li data-action="second">Second thing</li>
        <li data-action="third">Third thing</li>
</ul> -->

</div>
{:else}
<div class="loading-page">
    <div class="counter">
        <div class="boxLoading">
        </div>
        <h1>100%
        </h1>
        <div class="l_bar" style="width:100%"></div>
        <p>loading</p>

    </div>
</div>
{/if}




<!-- 
<h1>Dashboard : </h1>
<nav>
    <Link to="dashboard/profile">Profile</Link>
    <Link to="dashboard/settings">Settings</Link>
</nav>
<Router>
    <button>
        Clicked Dashboard {count} {count === 1 ? 'time' : 'times'}
    </button>
    <Route path="profile" component="{Profile}" />
    <Route path="settings">
        <Settings />
    </Route>
</Router> -->